










import { Vue, Component, Prop } from "vue-property-decorator";
import CustomButton from "@/components/form/CustomButton.vue";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";

@Component({ components: { CustomButton } })
export default class ShowMoreButton extends Vue {
  @Prop() payload: any;
  @Prop() params: any;
  @Prop({ default: "items" }) label!: string;
  @Prop() settings!: any;

  get items() {
    return this.$store.getters["showMore/ITEMS"];
  }

  get myParams() {
    let myParams: any;
    myParams = this.params;
    myParams.offset = this.$store.getters["showMore/OFFSET"];
    myParams.limit = this.$store.getters["showMore/LIMIT"];
    return myParams;
  }

  get screenWidth() {
    return window.innerWidth;
  }

  getItems() {
    this.$store.commit("showMore/CHANGE_IS_ACTION");
    this.payload(this.myParams)
      .then((res: { data: any }) => {
        this.$store.commit("showMore/SET_COUNT", res.data.count);
        this.$store.commit("showMore/ADD_ITEMS", res.data[this.label]);
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.$store.commit("showMore/CHANGE_IS_ACTION");
      });
  }

  showMore() {
    this.$store.commit("showMore/INCREASE_OFFSET");
    this.getItems();
  }

  beforeDestroy() {
    this.$store.commit("showMore/CLEAR_SHOW_MORE");
  }

  mounted() {
    this.getItems();
  }
}
